import { MessageComponentProps } from '@sprinx/react-globalize/types';
import comOrdersMessages from '@sprinx/react-i18n/react-com-orders/sl';
import comMessages from '@sprinx/react-i18n/react-com/sl';
import formsMessages from '@sprinx/react-i18n/react-forms/sl';
import compMessages from '@sprinx/react-i18n/react-mui-components/sl';
import fieldMessages from '@sprinx/react-i18n/react-mui-fields/sl';
import pagesMessages from '@sprinx/react-i18n/react-mui-pages/sl';
import tablesMessages from '@sprinx/react-i18n/react-mui-tables/sl';
import shoppingCartMessages from '@sprinx/react-i18n/react-shopping-cart/sl';
import shoppingListMessages from '@sprinx/react-i18n/react-shopping-lists/sl';
import messages from '../i18n/sl';

function MessagesSi({ children }: MessageComponentProps): JSX.Element {
  return children([
    compMessages,
    fieldMessages,
    tablesMessages,
    formsMessages,
    pagesMessages,
    comMessages,
    shoppingListMessages,
    shoppingCartMessages,
    comOrdersMessages,
    messages,
  ]);
}

export default MessagesSi;
